// src/components/Admin/ManageTestimonials.js
import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { collection, addDoc, deleteDoc, doc, getDocs, updateDoc } from 'firebase/firestore';


const ManageTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [newTestimonial, setNewTestimonial] = useState({ message: '', author: '' });
  const [editingTestimonial, setEditingTestimonial] = useState(null);

  // テスティモニアルをFirestoreから取得
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const testCol = collection(db, "testimonials");
        const testSnapshot = await getDocs(testCol);
        const testList = testSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTestimonials(testList);
      } catch (error) {
        console.error("テスティモニアル取得エラー:", error);
        alert('テスティモニアルの取得に失敗しました。');
      }
    };
    fetchTestimonials();
  }, []);

  // 新しいテスティモニアルを追加
  const handleAdd = async (e) => {
    e.preventDefault();
    if (newTestimonial.message.trim() === "" || newTestimonial.author.trim() === "") {
      alert("メッセージと著者名を入力してください。");
      return;
    }
    try {
      await addDoc(collection(db, "testimonials"), newTestimonial);
      setNewTestimonial({ message: '', author: '' });
      // 追加後に再取得
      const testSnapshot = await getDocs(collection(db, "testimonials"));
      setTestimonials(testSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      alert('テスティモニアルが追加されました。');
    } catch (error) {
      console.error("テスティモニアル追加エラー:", error);
      alert("テスティモニアルの追加に失敗しました。");
    }
  };

  // テスティモニアルを削除
  const handleDelete = async (id) => {
    if (!window.confirm("このテスティモニアルを削除してもよろしいですか？")) {
      return;
    }
    try {
      await deleteDoc(doc(db, "testimonials", id));
      setTestimonials(testimonials.filter(test => test.id !== id));
      alert('テスティモニアルが削除されました。');
    } catch (error) {
      console.error("テスティモニアル削除エラー:", error);
      alert("テスティモニアルの削除に失敗しました。");
    }
  };

  // テスティモニアルを編集
  const handleEdit = (testimonial) => {
    setEditingTestimonial(testimonial);
  };

  // 編集フォームの送信
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (editingTestimonial.message.trim() === "" || editingTestimonial.author.trim() === "") {
      alert("メッセージと著者名を入力してください。");
      return;
    }
    try {
      const testimonialRef = doc(db, "testimonials", editingTestimonial.id);
      await updateDoc(testimonialRef, {
        message: editingTestimonial.message,
        author: editingTestimonial.author,
      });
      setEditingTestimonial(null);
      // 再取得
      const testSnapshot = await getDocs(collection(db, "testimonials"));
      setTestimonials(testSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      alert('テスティモニアルが更新されました。');
    } catch (error) {
      console.error("テスティモニアル更新エラー:", error);
      alert("テスティモニアルの更新に失敗しました。");
    }
  };

  // 編集フォームのキャンセル
  const handleCancelEdit = () => {
    setEditingTestimonial(null);
  };

  return (
    <div className="manage-section">
      <h2>お客様の声管理</h2>
      {!editingTestimonial ? (
        <form onSubmit={handleAdd} className="manage-form">
          <label htmlFor="message">メッセージ</label>
          <textarea 
            id="message" 
            placeholder="お客様の声を入力してください。" 
            value={newTestimonial.message}
            onChange={(e) => setNewTestimonial({ ...newTestimonial, message: e.target.value })}
            required
          ></textarea>
          <label htmlFor="author">著者名</label>
          <input 
            type="text" 
            id="author" 
            placeholder="著者名を入力してください。" 
            value={newTestimonial.author}
            onChange={(e) => setNewTestimonial({ ...newTestimonial, author: e.target.value })}
            required
          />
          <button type="submit" className="button">追加</button>
        </form>
      ) : (
        <form onSubmit={handleUpdate} className="manage-form">
          <h3>テスティモニアルの編集</h3>
          <label htmlFor="edit-message">メッセージ</label>
          <textarea 
            id="edit-message" 
            placeholder="お客様の声を入力してください。" 
            value={editingTestimonial.message}
            onChange={(e) => setEditingTestimonial({ ...editingTestimonial, message: e.target.value })}
            required
          ></textarea>
          <label htmlFor="edit-author">著者名</label>
          <input 
            type="text" 
            id="edit-author" 
            placeholder="著者名を入力してください。" 
            value={editingTestimonial.author}
            onChange={(e) => setEditingTestimonial({ ...editingTestimonial, author: e.target.value })}
            required
          />
          <button type="submit" className="button">更新</button>
          <button type="button" className="button" onClick={handleCancelEdit}>キャンセル</button>
        </form>
      )}
      <ul className="manage-list">
        {testimonials.map(test => (
          <li key={test.id} className="manage-list-item">
            <p>"{test.message}"</p>
            <p>- {test.author}</p>
            {!editingTestimonial && (
              <>
                <button onClick={() => handleEdit(test)} className="button edit-button">編集</button>
                <button onClick={() => handleDelete(test.id)} className="button delete-button">削除</button>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ManageTestimonials;
